import { IQuestionModel } from '@care-portals/api-interfaces';

const libidoBelugaQuestion: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'libidoBeluga_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    isLast: true,
    blockQuestionFlow: true,
    answer: {}
  },
  {
    field: 'libidoBeluga_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },

  {
    label: 'What was your sex assigned at birth?',
    field: 'libidoBeluga_sexAssignedAtBirth',
    type: 'select',
    extras: { sendToBeluga: false },
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'libidoBeluga_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'libidoBeluga_pregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_pregnancy_yes',
          value: 'Yes'
        },
        {
          key: 'libidoBeluga_pregnancy_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Consent (Pregnancy)',
    educationalSlide: `I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. For example, medications which contain finasteride are known to cause significant birth defects in a fetus and child. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.

I agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.

I understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.

By selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.`,
    field: 'libidoBeluga_pregnancyConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_pregnancyConsent_disagree',
          class: 'option-decline',
          value: 'I have read the information and do NOT wish to proceed'
        },
        {
          key: 'libidoBeluga_pregnancyConsent_agree',
          class: 'option-consent',
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'libidoBeluga_height',
    type: 'info',
    answer: {
      name: 'libidoBeluga_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'libidoBeluga_weight',
    type: 'info',
    answer: {
      name: 'libidoBeluga_weight',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label:
      'What are your primary concerns related to your sexual health? Select all that apply',
    field: 'libidoBeluga_primaryConcerns',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'libidoBeluga_primaryConcerns_desire',
          value: 'Decreased sexual desire'
        },
        {
          key: 'libidoBeluga_primaryConcerns_arousal',
          value: 'Difficulty becoming aroused'
        },
        {
          key: 'libidoBeluga_primaryConcerns_orgasm',
          value: 'Difficulty achieving orgasm'
        },
        {
          key: 'libidoBeluga_primaryConcerns_pain',
          value: 'Pain during sexual activity'
        },
        {
          key: 'libidoBeluga_primaryConcerns_other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Tell us more about your sexual health symptoms',
    field: 'libidoBeluga_sexualHealthDetails',
    type: 'info',
    answer: {
      name: 'libidoBeluga_sexualHealthDetails',
      type: 'text',
      placeholder: 'Describe your symptoms'
    }
  },
  {
    label: 'Do you have any of the following conditions? Select all that apply',
    field: 'libidoBeluga_conditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'libidoBeluga_conditions_painSex',
          value: 'Pain with sex'
        },
        {
          key: 'libidoBeluga_conditions_vaginalDryness',
          value: 'Vaginal dryness'
        },
        {
          key: 'libidoBeluga_conditions_vaginalAtrophy',
          value: 'Vaginal atrophy'
        },
        {
          key: 'libidoBeluga_conditions_breastCancer',
          value: 'Breast cancer'
        },
        {
          key: 'libidoBeluga_conditions_uterineCancer',
          value: 'Uterine cancer'
        },
        {
          key: 'libidoBeluga_conditions_otherCancer',
          value: 'Other cancer'
        },
        {
          key: 'libidoBeluga_conditions_highBP',
          value: 'High blood pressure'
        },
        {
          key: 'libidoBeluga_conditions_lowBP',
          value: 'Low blood pressure'
        },
        {
          key: 'libidoBeluga_conditions_none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Please provide further information',
    field: 'libidoBeluga_conditionsDetails',
    type: 'info',
    answer: {
      name: 'libidoBeluga_conditionsDetails',
      type: 'text',
      placeholder: 'Provide additional information'
    }
  },
  {
    label: 'How long have you been experiencing these concerns?',
    field: 'libidoBeluga_duration',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_duration_less3',
          value: 'Less than 3 months'
        },
        {
          key: 'libidoBeluga_duration_3to6',
          value: '3 to 6 months'
        },
        {
          key: 'libidoBeluga_duration_more6',
          value: 'More than 6 months'
        }
      ]
    }
  },
  {
    label: 'Do these concerns cause you distress or affect your relationships?',
    field: 'libidoBeluga_distress',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_distress_yes',
          value: 'Yes'
        },
        {
          key: 'libidoBeluga_distress_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Are you currently sexually active?',
    field: 'libidoBeluga_sexuallyActive',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_sexuallyActive_yes',
          value: 'Yes'
        },
        {
          key: 'libidoBeluga_sexuallyActive_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you experienced any significant life changes or stressors recently? (e.g., relationship changes, job loss, bereavement)',
    field: 'libidoBeluga_recentStressors',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_recentStressors_yes',
          value: 'Yes'
        },
        {
          key: 'libidoBeluga_recentStressors_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you had a physical exam with a healthcare provider in the past 5 years?',
    field: 'libidoBeluga_physicalExam',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_physicalExam_goodHealth',
          value: 'Yes, I am in good health'
        },
        {
          key: 'libidoBeluga_physicalExam_foundProblems',
          value: 'Yes, but they found problems'
        },
        {
          key: 'libidoBeluga_physicalExam_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please explain any issues during your last physical exam',
    field: 'libidoBeluga_physicalExamDetails',
    type: 'info',
    answer: {
      name: 'libidoBeluga_physicalExamDetails',
      type: 'text',
      placeholder: 'Describe issues from physical exam'
    }
  },
  {
    label: 'Was your blood pressure taken in the past year?',
    field: 'libidoBeluga_bloodPressure',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_bloodPressure_yes',
          value: 'Yes'
        },
        {
          key: 'libidoBeluga_bloodPressure_no',
          value: 'No, I will get a new blood pressure measurement'
        }
      ]
    }
  },
  {
    label: 'What was the value? (Example: 115/72)',
    field: 'libidoBeluga_bloodPressureValue',
    type: 'info',
    answer: {
      name: 'libidoBeluga_bloodPressureValue',
      type: 'text',
      placeholder: 'Enter blood pressure value'
    }
  },
  {
    label: 'Do you take any of the following medicines? Select all that apply',
    field: 'libidoBeluga_specificMedications',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'libidoBeluga_specificMedications_nitroglycerin',
          value: 'Nitroglycerin spray, ointment, patches or tablets'
        },
        {
          key: 'libidoBeluga_specificMedications_isosorbide',
          value:
            'Isosorbide mononitrate, or isosorbide dinitrate (Isordil, Dilatrate, Sorbitrate, Imdur, Ismo, Monoket)'
        },
        {
          key: 'libidoBeluga_specificMedications_nitrates',
          value: 'Other medicines containing nitrates'
        },
        {
          key: 'libidoBeluga_specificMedications_alphablockers',
          value:
            'Alpha blocker medications: doxazosin (Cardura), prazosin (Minipress), terazosin (Hytrin)'
        },
        {
          key: 'libidoBeluga_specificMedications_riociguat',
          value: 'Riociguat (Adempas)'
        },
        {
          key: 'libidoBeluga_specificMedications_none',
          value: 'None apply',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Do you experience any of the following cardiovascular symptoms?',
    field: 'libidoBeluga_cardiovascularSymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'libidoBeluga_cardiovascularSymptoms_chestPainStairs',
          value:
            'Chest pain or shortness of breath when climbing 2 flights of stairs or walking 4 blocks'
        },
        {
          key: 'libidoBeluga_cardiovascularSymptoms_chestPainSex',
          value: 'Chest pain or shortness of breath with sexual activity'
        },
        {
          key: 'libidoBeluga_cardiovascularSymptoms_fainting',
          value: 'Unexplained fainting or dizziness'
        },
        {
          key: 'libidoBeluga_cardiovascularSymptoms_legCramps',
          value: 'Prolonged cramping of the legs with exercise'
        },
        {
          key: 'libidoBeluga_cardiovascularSymptoms_abnormalHeartbeats',
          value: 'Abnormal heart beats or rhythms'
        },
        {
          key: 'libidoBeluga_cardiovascularSymptoms_none',
          value: 'None of these apply to me',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'libidoBeluga_additionalInfo',
    type: 'info',
    answer: {
      name: 'libidoBeluga_additionalInfo',
      type: 'text',
      placeholder: 'Additional information or questions'
    }
  },
  {
    label: 'Consent (PT-141, Oxytocin, and Medications for Female Libido)',
    educationalSlide: `This consent form provides detailed information about PT-141 (Bremelanotide), oxytocin, and other medications prescribed to address low female libido. It is essential to understand the purpose, potential benefits, risks, side effects, and your responsibilities throughout this treatment. Please review the following information carefully.

Purpose and Benefits
Medications such as PT-141 and oxytocin are used to enhance sexual desire through complementary mechanisms:
PT-141 (Bremelanotide):
   - Acts centrally by stimulating melanocortin receptors, which may boost sexual desire.
   - Can lead to increased arousal and improved overall sexual satisfaction.
Oxytocin:
   - Often known as the "bonding hormone," oxytocin is believed to promote emotional closeness and trust between partners.
   - May enhance intimacy and contribute to a more fulfilling sexual experience.
These treatments aim to improve libido, foster intimacy, and contribute to overall emotional well-being.

Potential Risks and Side Effects
While these medications offer potential benefits, they also carry risks and side effects that may vary from person to person.
Common Side Effects:
For PT-141:
   - Nausea or upset stomach
   - Headaches
   - Flushing or redness
   - Dizziness or lightheadedness
   - Injection site reactions (if applicable)
For Oxytocin:
   - Mild headache
   - Nausea
   - Temporary changes in blood pressure
   - Possible mood alterations
Rare but Serious Risks:
- Significant changes in blood pressure
- Severe allergic reactions, including swelling of the face, lips, tongue, or throat
- Noticeable changes in mood or behavior that cause concern

Allergy Warning:
This formulation may contain inactive ingredients that could trigger allergic reactions. If you have a known allergy (for example, to any component such as peanut oil or other additives), please inform your healthcare provider before initiating treatment.

If you experience severe symptoms such as chest pain, difficulty breathing, extreme dizziness, or signs of an allergic reaction, seek immediate medical attention.

Monitoring Plan
Your healthcare provider will monitor your progress and response to these treatments to ensure their continued safety and effectiveness. This includes:
- Attending all scheduled follow-up appointments
- Routine evaluations and necessary diagnostic tests
- Reporting any new or worsening symptoms promptly

Alternative Treatments
You have the right to discuss alternative approaches for managing low female libido, which may include:
- Non-Pharmacological Therapies: Counseling, sex therapy, or relationship therapy
- Lifestyle Modifications: Regular exercise, improved sleep habits, stress reduction, and nutritional adjustments
- Other Medications or Hormonal Therapies: Depending on your overall health and specific needs, additional treatment options may be considered

Your Responsibilities
As a patient undergoing this treatment, you agree to:
- Follow the prescribed dosage and administration instructions precisely
- Attend all follow-up appointments and complete recommended tests or evaluations
- Inform your healthcare provider of any new medications, supplements, or changes in your health status
- Report any concerning side effects or unusual symptoms immediately

Consent
By selecting below, you confirm that you have read and understood the information provided. You acknowledge the potential benefits and risks associated with the prescribed hormone therapy.. You agree to adhere to the recommended use, monitoring plan, and to communicate openly with your healthcare
provider about any concerns.`,
    field: 'libidoBeluga_treatmentConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'libidoBeluga_treatmentConsent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information, and I do NOT wish to proceed.'
        },
        {
          key: 'libidoBeluga_treatmentConsent_agree',
          class: 'option-consent',
          value:
            'I have read the above information, I understand the risks, and I would like to proceed.'
        }
      ]
    }
  }
];

export default libidoBelugaQuestion;
